module.exports = __webpack_public_path__ + "asobi.dc2563a.png";